import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import trustedHtml from 'rise-ui/helpers/trusted-html.js';

export default RouteTemplate(class PageTemplate extends Component {
  <template>
    {{#if @model.page.image.url}}
      <span class="c-image-callout">
        <img src={{@model.page.image.url}} alt={{@model.page.image.alt}}>
        <br>
        <small>{{@model.page.image.alt}}</small>
      </span>
    {{/if}}

    <h3 class="c-page-title qa-page-title">{{@model.page.title}}</h3>
    <div class="c-html-content">
      {{trustedHtml @model.page.bodyProcessed}}
    </div>

    {{outlet}}
  </template>
});
